// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"240c0077","793":"aae2a880"}[chunkId] + ".chunk.css";
};